import { ProductPriceDetails } from "../../../product-price/types"

export type ItemsResultDto = {
    data: ProductPriceDetails[],
    metadata: {
        activePage: number,
        pageSize: number,
        totalItemsCount: number
    }
}

export default class ItemsResult {
    data: ItemsResultDto

    constructor(dto: ItemsResultDto) {
        this.data = {
            data: dto.data,
            metadata: {
                activePage: dto.metadata.activePage,
                pageSize: dto.metadata.pageSize,
                totalItemsCount: dto.metadata.totalItemsCount
            }
        }
    }

    getListing() {
        return this.data.data
    }
}



// WEBPACK FOOTER //
// ./src/state/listing/product-price/models/productPricesWithProductInfoItemsResult.ts